import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import { ProgressBar } from "react-bootstrap";

import * as projectActions from "../../../actions/projectActions";
import * as userActions from "../../../actions/userActions";
import * as codeActions from "../../../actions/codeActions";
import * as modalActions from "../../../actions/modalActions";

import ProjectTaskForm from "./ProjectTaskForm";
import ProjectTaskList from "./ProjectTaskList";
import HeaderWrapper from "../../common/HeaderWrapper";
import Modal from "../../common/Modal";
import ConfirmModal from "../../common/ConfirmModal";

class ProjectTasksPage extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { task: {}, adding: false };
  }

  componentDidMount = () => {
    const { users, match, actions } = this.props;
    if (!users.length) actions.loadUsers();

    actions.getProject(match.params.id);
  };

  onClickAdd = () => {
    this.setState({ task: {}, adding: true });
    this.props.actions.showModalSuccess("projectDetailsModal");
  };

  onClickEdit = (taskId) => {
    const { project } = this.props;
    const task = project.tasks.find((tsk) => tsk._id === taskId);
    this.setState({ task, adding: false });
    this.props.actions.showModalSuccess("projectDetailsModal");
  };

  onClickDelete = (projectTaskId) => {
    this.props.actions.requestTaskId(projectTaskId);
  };

  onClickCheck = (projectTaskId) => {
    const { project } = this.props;
    const { tasks } = project;
    const task = find(tasks, { id: projectTaskId });
    if (task) {
      task.is_complete = !task.is_complete;
      project.tasks = [
        ...tasks.filter((tsk) => tsk.id !== projectTaskId),
        { ...task }
      ];
    }
    this.props.actions.updateProject(project, false);
  };

  handleAdd = (task) => {
    const { project } = this.props;
    this.props.actions.createTask(project._id, task);
  };

  handleSave = (task) => {
    const { project } = this.props;
    this.props.actions.updateTask(project._id, task);
  };

  handleDelete = () => {
    const { project, projectTaskToDelete } = this.props;
    this.props.actions.deleteTask(project._id, projectTaskToDelete);
  };

  handleCancel = () => {
    this.props.actions.hideModal();
  };

  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { project, users, codes, isMobile } = this.props;
    const { task, search, adding } = this.state;

    const taskForm = (
      <ProjectTaskForm
        project={project}
        task={task}
        users={users}
        codes={codes}
        adding={adding}
        onAdd={this.handleAdd}
        onSave={this.handleSave}
        onCancel={this.handleCancel}
      />
    );
    return (
      <React.Fragment>
        <HeaderWrapper
          breadcrumbs={[{ label: project.name }, { label: "Tasks" }]}
          onClickEdit={this.handleEdit}
          onClickAdd={this.onClickAdd}
          onFilter={this.filter}
          isMobile={isMobile}
        />
        <ProjectProgressBar project={project} track="tasks" />
        <div className="content-wrapper">
          <ProjectTaskList
            project={project}
            users={users}
            search={search}
            isMobile={isMobile}
            onClickCheck={this.onClickCheck}
            onClickEdit={this.onClickEdit}
            onClickDelete={this.onClickDelete}
          />
          <Modal
            id="projectDetailsModal"
            title={adding ? "Add Task" : task.description}
            body={taskForm}
            close={this.props.actions.hideModal}
          />
          <ConfirmModal
            id="taskDeleteModal"
            title="Delete Task"
            body="Are you sure you want to delete this task?"
            close={this.props.actions.hideModal}
            confirm={this.handleDelete}
          />
        </div>
      </React.Fragment>
    );
  }
}

ProjectTasksPage.propTypes = {
  actions: PropTypes.object.isRequired,
  project: PropTypes.object,
  codes: PropTypes.array,
  users: PropTypes.array,
  match: PropTypes.object,
  params: PropTypes.object,
  projectTaskToDelete: PropTypes.object,
  isMobile: PropTypes.bool
};

const ProjectProgressBar = ({ project }) => {
  if (!project || isEmpty(project.tasks)) return null;
  const completedHours = project.tasks
    .filter((task) => task.is_complete)
    .reduce((total, task) => total + task.estimated_hrs, 0);
  const completedPercentage = (completedHours / project.budget_hours) * 100;

  return (
    <div className="content-wrapper">
      <ProgressBar
        style={{ marginBottom: 0 }}
        striped
        bsStyle="success"
        now={completedPercentage}
        label={`${completedHours} / ${project.budget_hours} HRS`}
      />
    </div>
  );
};

ProjectProgressBar.propTypes = {
  project: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    project: state.reducers.project,
    codes: state.reducers.codes,
    users: state.reducers.users,
    projectTaskToDelete: state.reducers.projectTaskToDelete
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...projectActions,

        ...userActions,
        ...codeActions,
        ...modalActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ProjectTasksPage);
